"use client";

import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/language-context';

export default function NotFound() {
  const { t } = useLanguage();

  return (
    <section className="relative flex min-h-[60vh] items-center justify-center px-4 pt-32 pb-20 sm:px-6 lg:px-8">
      <div className="text-center">
        <h1 className="mb-4 text-7xl md:text-8xl font-bold bg-gradient-to-r from-cloud-blue to-cloud-lavender bg-clip-text text-transparent">
          404
        </h1>
        <h2 className="mb-4 text-3xl md:text-4xl font-bold text-deep-purple dark:text-cream text-balance">
          {t('notFound.title')}
        </h2>
        <p className="mx-auto mb-8 max-w-xl text-lg md:text-xl text-deep-purple/80 dark:text-cream/80 text-balance">
          {t('notFound.description')}
        </p>
        <Button
          asChild
          size="lg"
          className="bg-gradient-to-r from-cloud-blue to-cloud-lavender hover:from-cloud-blue/90 hover:to-cloud-lavender/90 text-white px-8 py-6 text-lg font-semibold rounded-full shadow-lg hover:shadow-xl transition-all duration-300 gradient-button"
        >
          <Link href="/">{t('notFound.backHome')}</Link>
        </Button>
      </div>
    </section>
  );
}
